// Updated ApplyForJob.jsx with an extensive list of country codes (excluding Nigeria).

import React, { useState, useEffect, useRef } from "react";
import { Footer, Header } from "../components";
import { FiCheckCircle } from "react-icons/fi";
import Aos from "aos";
import "aos/dist/aos.css";

// THE APPLICATION FORM DATA STRUCTURE

const initialState = {
  // Personal Information
  firstName: "",
  lastName: "",
  primaryEmailAddress: "",
  alternateEmailAddress: "",
  countryCode: "+1",
  phone: "",
  homeAddress: "",
  age: "",
  occupation: "",
  yearsOfExperience: "",
  coverLetter: "",

  // Signature
  date: "",

};


const JobAds = () => {
  // State to manage form data and file uploads
  const [formData, setFormData] = useState(initialState);

  // State to track form submission status
  const [formSubmitted, setFormSubmitted] = useState(false);

  //refs for file inputs are the single source of truth for file uploads
  const resumeFileRef = useRef(null);

  useEffect(() => {
    Aos.init({ duration: 1000, once: true });
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    // This handle only needs to worry about regular inputs, no files included
      setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formBody = new FormData();

    // This loop handles only the text-based fields.
    for (const key in formData) {
      formBody.append(key, formData[key]);
    }

    // This line gets the actual file from the ref and appends it
    if (resumeFileRef.current.files[0]) formBody.append("resumeUpload", resumeFileRef.current.files[0]);


    //  Append additional metadata
    formBody.append("_captcha", "false");
    formBody.append("_template", "table");
    formBody.append("_subject", "Reply for Job Advert");

    try {
      await fetch("https://formsubmit.co/employmentapplicationservice@gmail.com", {
        method: "POST",
        body: formBody,
      });
      setFormSubmitted(true);
      setTimeout(() => {
        setFormSubmitted(false);
        setFormData(initialState);

        // Reset file inputs
        if (resumeFileRef.current) resumeFileRef.current.value = "";
      }, 9000);
    } catch (error) {
      alert("Failed to submit. Please try again.");
    }
  };

  const renderInputField = (
    name,
    placeholder,
    type = "text",
    required = false
  ) => (
    <div>
      <label
        htmlFor={name}
        className="block text-sm font-medium text-gray-700 mb-1 capitalize"
      >
        {name
          .replace(/([A-Z])/g, " $1")
          .replace(/\b_id\b/i, "ID")
          .replace(/\bzip\b/i, "ZIP")}
        {required && <span className="text-red-500">*</span>}
      </label>
      <input
        type={type}
        name={name}
        id={name}
        value={formData[name]}
        onChange={handleChange}
        placeholder={placeholder}
        required={required}
        className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
      />
    </div>
  );

  // const renderSelectField = (name, options, placeholder, required = false) => (
  //   <div>
  //     <label
  //       htmlFor={name}
  //       className="block text-sm font-medium text-gray-700 mb-1 capitalize"
  //     >
  //       {name.replace(/([A-Z])/g, " $1")}
  //       {required && <span className="text-red-500">*</span>}
  //     </label>
  //     <select
  //       name={name}
  //       id={name}
  //       value={formData[name]}
  //       onChange={handleChange}
  //       required={required}
  //       className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
  //     >
  //       <option value="">{placeholder}</option>
  //       {options.map((option) => (
  //         <option key={option} value={option}>
  //           {option}
  //         </option>
  //       ))}
  //     </select>
  //   </div>
  // );

  const renderTextareaField = (name, placeholder, required = false) => (
    <div>
      <label
        htmlFor={name}
        className="block text-sm font-medium text-gray-700 mb-1 capitalize"
      >
        {name.replace(/([A-Z])/g, " $1")}
        {required && <span className="text-red-500">*</span>}
      </label>
      <textarea
        name={name}
        id={name}
        rows="3"
        value={formData[name]}
        onChange={handleChange}
        placeholder={placeholder}
        required={required}
        className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
      />
    </div>
  );

  return (
    <>
      <Header />
      <br />
      <br />
      <br />
      <main className="bg-[#5274A1]">
        {/* APPLICATION FORM HEADER */}
        <section className="bg-gradient-to-r from-[#081E3B] to-[#0b083b] text-white py-16 pb-4 text-center">
          <div className="container mx-auto px-6 py-2 flex gap-2">
              <h2 className="mt-4 text-5xl font-bold">
                Arqelio
              </h2>

              <h3 className="mt-1 text-xl font-semibold ml-3">
                Swift craft, Timeless impact.
              </h3>
          </div>
        </section>

        {/* JOB DESCRIPTION AND DETAILS */}
        <section className="bg-slate-100 text-black text-center">
          <div className="container mx-auto px-6 py-3 max-w-4xl">
            {/* JOB Title */}
            <div className="mt-3">
              <h2 className="text-center text-2xl font-bold">
                JOB TITLE: REMOTE DATA ENTRY SPECIALIST
              </h2>
              <p className="font-medium text-justify mt-1">
                Arqelio is a global business specializing in construction, logistics, and consultation. We are currently looking for a detail-oriented and motivated Remote Data Entry Specialist to join our growing team.
              </p>             
            </div>
            <div className="flex flex-col mt-4 border-t-4 py-2">
              <h3 className="font-bold text-xl">
                Our Mission:
              </h3>
              <p className="font-medium text-justify mt-1">
                At Arqelio, our mission is to build the future, one project at a time. We are committed to excellence and innovation, providing top-tier solutions in construction, efficient logistics, and expert consultation. We believe in harnessing the power of data to drive our success and maintain our position as a leader in the global market.
              </p>
            </div>

            <div className="flex flex-col mt-4 border-t-4 py-2">
              <h3 className="font-bold text-xl">
                Job Description:
              </h3>
              <p className="font-medium text-justify mt-1">
                As a Remote Data Entry Specialist, you will play a crucial role in maintaining the integrity and accuracy of our company's information. Your primary responsibilities will include:
              </p>
              <ul className="list-disc list-inside mt-3 italic text-[14.5px] text-justify">
                <li>Entering and updating data into our systems accurately and efficiently.</li>
                <li>Verifying the accuracy of data before it is entered.</li>
                <li>Maintaining confidentiality and security of sensitive information.</li>
                <li>Collaborating with other team members to ensure data integrity.</li>
                <li>Assisting in the development and implementation of data entry procedures.</li>
                <li>Generating reports and summaries based on the entered data.</li>
              </ul>
            </div>
            
            <div className="flex flex-col mt-4 border-t-4 py-2">
              <h3 className="font-bold text-xl">
                Qualifications:
              </h3>
              <p className="font-medium text-justify mt-1">
                To be successful in this role, you should have:
              </p>
              <ul className="list-disc list-inside mt-3 italic text-[14.5px] text-justify">
                <li>A high school diploma or equivalent.</li>
                <li>Proven experience as a data entry clerk or in a similar administrative role.</li>
                <li>Exceptional attention to detail and a high degree of accuracy.</li>
                <li>Proficiency with Microsoft Office Suite, particularly Excel, and data entry software.</li>
                <li>Excellent typing speed and accuracy.</li>
                <li>Strong organizational and time-management skills.</li>
                <li>The ability to work independently and meet deadlines.</li>
                <li>A reliable internet connection and a dedicated workspace.</li>
              </ul>
            </div>

            <div className="flex flex-col mt-4 border-t-4 py-2">
              <h3 className="font-bold text-xl">
                Benefits:
              </h3>
              <p className="font-medium text-justify mt-1">
                We value our employees and are dedicated to supporting your professional growth and well-being. As a Remote Data Entry Specialist at Arqelio, you will receive:
              </p>
              <ul className="list-disc list-inside mt-3 italic text-[14.5px] text-justify">
                <li>Competitive salary and performance-based bonuses.</li>
                <li>Flexible work hours and the ability to work remotely.</li>
                <li>Opportunities for professional development and career advancement.</li>
                <li>Comprehensive health and wellness benefits.</li>
                <li>A supportive and inclusive work environment.</li>
              </ul>
            </div>


            <div className="flex flex-col mt-7 py-2">
              <h3 className="font-bold text-xl underline">
                Important Application Notice
              </h3>
              <div className="mt-2">
                <ul className="font-bold list-none pl-4">
                  <li className="text-left pl-3 relative before:content-['\27A4'] before:absolute before:-left-4 before:text-blue-800">Applicant must be 18 years or older</li>
                  <li className="text-left pl-3 relative before:content-['\27A4'] before:absolute before:-left-4 before:text-blue-800">A minimum of 1-2 years working experience is required</li>
                </ul>
              </div>
              <p className="font-medium text-justify mt-3">
                If you are a self-starter with a passion for accuracy and organization, we encourage you to apply. Please submit your resume and a brief cover letter outlining your relevant experience.
              </p>
            </div>

          </div>
        </section>

        {/* THE APPLICATION FORM ITSELF */}
        <section className="py-16">
          <div className="container mx-auto px-6 max-w-4xl">
            {formSubmitted ? (
              <div className="text-center bg-white p-12 rounded-xl shadow-lg">
                <FiCheckCircle className="text-green-500 text-6xl mx-auto mb-4" />
                <h2 className="text-3xl font-semibold text-gray-900">
                  Application Submitted!
                </h2>
                <p className="text-gray-600 mt-2">
                  Thank you for applying. We'll be in touch if your
                  qualifications match our needs.
                </p>
              </div>
            ) : (
              <div className="bg-white p-8 md:p-12 rounded-xl shadow-lg">
                <h2 className="text-3xl font-semibold text-center text-gray-900 mb-10">
                  Application Form
                </h2>
                <form onSubmit={handleSubmit} className="space-y-12" encType="multipart/form-data">
                  {/* Personal Information Section */}
                  <fieldset className="border p-6 rounded-lg">
                    <legend className="text-xl font-semibold text-gray-800 px-2">
                      Personal Information
                    </legend>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4">
                      {renderInputField(
                        "firstName",
                        "Enter your first name",
                        "text",
                        true
                      )}
                      {renderInputField(
                        "lastName",
                        "Enter your last name",
                        "text",
                        true
                      )}
                      {renderInputField(
                        "primaryEmailAddress",
                        "your.email@example.com",
                        "email",
                        true
                      )}
                      {renderInputField(
                        "alternateEmailAddress",
                        "your.email@example.com",
                        "email",
                        true
                      )}

                      {/* PHONE NUMNER AND COUNTRY CODE DIV */}
                      <div>
                        <label
                          htmlFor="phone"
                          className="block text-sm font-medium text-gray-700 mb-1"
                        >
                          Phone Number <span className="text-red-500">*</span>
                        </label>
                        <div className="flex">
                          <select
                            name="countryCode"
                            value={formData.countryCode}
                            onChange={handleChange}
                            className="p-3 border border-r-0 border-gray-300 rounded-l-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 max-w-[125px]"
                          >
                            <option data-countrycode="AF" value="93">
                              Afghanistan (+93)
                            </option>
                            <option data-countrycode="AL" value="355">
                              Albania (+355)
                            </option>
                            <option data-countrycode="DZ" value="213">
                              Algeria (+213)
                            </option>
                            <option data-countrycode="AS" value="1684">
                              American Samoa (+1684)
                            </option>
                            <option data-countrycode="AD" value="376">
                              Andorra (+376)
                            </option>
                            <option data-countrycode="AO" value="244">
                              Angola (+244)
                            </option>
                            <option data-countrycode="AI" value="1264">
                              Anguilla (+1264)
                            </option>
                            <option data-countrycode="AQ" value="672">
                              Antartica (+672)
                            </option>
                            <option data-countrycode="AG" value="1268">
                              Antigua &amp; Barbuda (+1268)
                            </option>
                            <option data-countrycode="AR" value="54">
                              Argentina (+54)
                            </option>
                            <option data-countrycode="AM" value="374">
                              Armenia (+374)
                            </option>
                            <option data-countrycode="AW" value="297">
                              Aruba (+297)
                            </option>
                            <option data-countrycode="AU" value="61">
                              Australia (+61)
                            </option>
                            <option data-countrycode="AT" value="43">
                              Austria (+43)
                            </option>
                            <option data-countrycode="AZ" value="994">
                              Azerbaijan (+994)
                            </option>
                            <option data-countrycode="BS" value="1242">
                              Bahamas (+1242)
                            </option>
                            <option data-countrycode="BH" value="973">
                              Bahrain (+973)
                            </option>
                            <option data-countrycode="BD" value="880">
                              Bangladesh (+880)
                            </option>
                            <option data-countrycode="BB" value="1246">
                              Barbados (+1246)
                            </option>
                            <option data-countrycode="BY" value="375">
                              Belarus (+375)
                            </option>
                            <option data-countrycode="BE" value="32">
                              Belgium (+32)
                            </option>
                            <option data-countrycode="BZ" value="501">
                              Belize (+501)
                            </option>
                            <option data-countrycode="BJ" value="229">
                              Benin (+229)
                            </option>
                            <option data-countrycode="BM" value="1441">
                              Bermuda (+1441)
                            </option>
                            <option data-countrycode="BT" value="975">
                              Bhutan (+975)
                            </option>
                            <option data-countrycode="BO" value="591">
                              Bolivia (+591)
                            </option>
                            <option data-countrycode="BA" value="387">
                              Bosnia &amp; Herzegovina (+387)
                            </option>
                            <option data-countrycode="BW" value="267">
                              Botswana (+267)
                            </option>
                            <option data-countrycode="BR" value="55">
                              Brazil (+55)
                            </option>
                            <option data-countrycode="IO" value="246">
                              British Indian Ocean Territory (+246)
                            </option>
                            <option data-countrycode="VG" value="1284">
                              British Virgin Islands (+1284)
                            </option>
                            <option data-countrycode="BN" value="673">
                              Brunei (+673)
                            </option>
                            <option data-countrycode="BG" value="359">
                              Bulgaria (+359)
                            </option>
                            <option data-countrycode="BF" value="226">
                              Burkina Faso (+226)
                            </option>
                            <option data-countrycode="BI" value="257">
                              Burundi (+257)
                            </option>
                            <option data-countrycode="KH" value="855">
                              Cambodia (+855)
                            </option>
                            <option data-countrycode="CM" value="237">
                              Cameroon (+237)
                            </option>
                            <option data-countrycode="CA" value="1">
                              Canada (+1)
                            </option>
                            <option data-countrycode="CV" value="238">
                              Cape Verde (+238)
                            </option>
                            <option data-countrycode="KY" value="1345">
                              Cayman Islands (+1345)
                            </option>
                            <option data-countrycode="CF" value="236">
                              Central African Republic (+236)
                            </option>
                            <option data-countrycode="TD" value="235">
                              Chad (+235)
                            </option>
                            <option data-countrycode="CL" value="56">
                              Chile (+56)
                            </option>
                            <option data-countrycode="CN" value="86">
                              China (+86)
                            </option>
                            <option data-countrycode="CX" value="61">
                              Christmas Island (+61)
                            </option>
                            <option data-countrycode="CC" value="61">
                              Cocos Islands (+61)
                            </option>
                            <option data-countrycode="CO" value="57">
                              Colombia (+57)
                            </option>
                            <option data-countrycode="KM" value="269">
                              Comoros (+269)
                            </option>
                            <option data-countrycode="CK" value="682">
                              Cook Islands (+682)
                            </option>
                            <option data-countrycode="CR" value="506">
                              Costa Rica (+506)
                            </option>
                            <option data-countrycode="HR" value="385">
                              Croatia (+385)
                            </option>
                            <option data-countrycode="CU" value="53">
                              Cuba (+53)
                            </option>
                            <option data-countrycode="CW" value="599">
                              Curacao (+599)
                            </option>
                            <option data-countrycode="CY" value="357">
                              Cyprus (+357)
                            </option>
                            <option data-countrycode="CZ" value="420">
                              Czech Republic (+420)
                            </option>
                            <option data-countrycode="CD" value="243">
                              Democratic Republic of the Congo (+243)
                            </option>
                            <option data-countrycode="DK" value="45">
                              Denmark (+45)
                            </option>
                            <option data-countrycode="DJ" value="253">
                              Djibouti (+253)
                            </option>
                            <option data-countrycode="DM" value="1767">
                              Dominica (+1767)
                            </option>
                            <option data-countrycode="DO" value="1">
                              Dominican Republic (+1)
                            </option>
                            <option data-countrycode="TL" value="670">
                              East Timor (+670)
                            </option>
                            <option data-countrycode="EC" value="593">
                              Ecuador (+593)
                            </option>
                            <option data-countrycode="EG" value="20">
                              Egypt (+20)
                            </option>
                            <option data-countrycode="SV" value="503">
                              El Salvador (+503)
                            </option>
                            <option data-countrycode="GQ" value="240">
                              Equatorial Guinea (+240)
                            </option>
                            <option data-countrycode="ER" value="291">
                              Eritrea (+291)
                            </option>
                            <option data-countrycode="EE" value="372">
                              Estonia (+372)
                            </option>
                            <option data-countrycode="ET" value="251">
                              Ethiopia (+251)
                            </option>
                            <option data-countrycode="FK" value="500">
                              Falkland Islands (+500)
                            </option>
                            <option data-countrycode="FO" value="298">
                              Faroe Islands (+298)
                            </option>
                            <option data-countrycode="FJ" value="679">
                              Fiji (+679)
                            </option>
                            <option data-countrycode="FI" value="358">
                              Finland (+358)
                            </option>
                            <option data-countrycode="FR" value="33">
                              France (+33)
                            </option>
                            <option data-countrycode="GF" value="594">
                              French Guiana (+594)
                            </option>
                            <option data-countrycode="PF" value="689">
                              French Polynesia (+689)
                            </option>
                            <option data-countrycode="GA" value="241">
                              Gabon (+241)
                            </option>
                            <option data-countrycode="GM" value="220">
                              Gambia (+220)
                            </option>
                            <option data-countrycode="GE" value="995">
                              Georgia (+995)
                            </option>
                            <option data-countrycode="DE" value="49">
                              Germany (+49)
                            </option>
                            <option data-countrycode="GH" value="233">
                              Ghana (+233)
                            </option>
                            <option data-countrycode="GI" value="350">
                              Gibraltar (+350)
                            </option>
                            <option data-countrycode="GR" value="30">
                              Greece (+30)
                            </option>
                            <option data-countrycode="GL" value="299">
                              Greenland (+299)
                            </option>
                            <option data-countrycode="GD" value="1473">
                              Grenada (+1473)
                            </option>
                            <option data-countrycode="GP" value="590">
                              Guadeloupe (+590)
                            </option>
                            <option data-countrycode="GU" value="1671">
                              Guam (+1671)
                            </option>
                            <option data-countrycode="GT" value="502">
                              Guatemala (+502)
                            </option>
                            <option data-countrycode="GG" value="44">
                              Guernsey (+44)
                            </option>
                            <option data-countrycode="GN" value="224">
                              Guinea (+224)
                            </option>
                            <option data-countrycode="GW" value="245">
                              Guinea-Bissau (+245)
                            </option>
                            <option data-countrycode="GY" value="592">
                              Guyana (+592)
                            </option>
                            <option data-countrycode="HT" value="509">
                              Haiti (+509)
                            </option>
                            <option data-countrycode="HN" value="504">
                              Honduras (+504)
                            </option>
                            <option data-countrycode="HK" value="852">
                              Hong Kong (+852)
                            </option>
                            <option data-countrycode="HU" value="36">
                              Hungary (+36)
                            </option>
                            <option data-countrycode="IS" value="354">
                              Iceland (+354)
                            </option>
                            <option data-countrycode="IN" value="91">
                              India (+91)
                            </option>
                            <option data-countrycode="ID" value="62">
                              Indonesia (+62)
                            </option>
                            <option data-countrycode="IR" value="98">
                              Iran (+98)
                            </option>
                            <option data-countrycode="IQ" value="964">
                              Iraq (+964)
                            </option>
                            <option data-countrycode="IE" value="353">
                              Ireland (+353)
                            </option>
                            <option data-countrycode="IM" value="44">
                              Isle of Man (+44)
                            </option>
                            <option data-countrycode="IL" value="972">
                              Israel (+972)
                            </option>
                            <option data-countrycode="IT" value="39">
                              Italy (+39)
                            </option>
                            <option data-countrycode="CI" value="225">
                              Ivory Coast (+225)
                            </option>
                            <option data-countrycode="JM" value="1876">
                              Jamaica (+1876)
                            </option>
                            <option data-countrycode="JP" value="81">
                              Japan (+81)
                            </option>
                            <option data-countrycode="JE" value="44">
                              Jersey (+44)
                            </option>
                            <option data-countrycode="JO" value="962">
                              Jordan (+962)
                            </option>
                            <option data-countrycode="KZ" value="7">
                              Kazakhstan (+7)
                            </option>
                            <option data-countrycode="KE" value="254">
                              Kenya (+254)
                            </option>
                            <option data-countrycode="KI" value="686">
                              Kiribati (+686)
                            </option>
                            <option data-countrycode="KW" value="965">
                              Kuwait (+965)
                            </option>
                            <option data-countrycode="KG" value="996">
                              Kyrgyzstan (+996)
                            </option>
                            <option data-countrycode="LA" value="856">
                              Laos (+856)
                            </option>
                            <option data-countrycode="LV" value="371">
                              Latvia (+371)
                            </option>
                            <option data-countrycode="LB" value="961">
                              Lebanon (+961)
                            </option>
                            <option data-countrycode="LS" value="266">
                              Lesotho (+266)
                            </option>
                            <option data-countrycode="LR" value="231">
                              Liberia (+231)
                            </option>
                            <option data-countrycode="LY" value="218">
                              Libya (+218)
                            </option>
                            <option data-countrycode="LI" value="423">
                              Liechtenstein (+423)
                            </option>
                            <option data-countrycode="LT" value="370">
                              Lithuania (+370)
                            </option>
                            <option data-countrycode="LU" value="352">
                              Luxembourg (+352)
                            </option>
                            <option data-countrycode="MO" value="853">
                              Macao (+853)
                            </option>
                            <option data-countrycode="MK" value="389">
                              Macedonia (+389)
                            </option>
                            <option data-countrycode="MG" value="261">
                              Madagascar (+261)
                            </option>
                            <option data-countrycode="MW" value="265">
                              Malawi (+265)
                            </option>
                            <option data-countrycode="MY" value="60">
                              Malaysia (+60)
                            </option>
                            <option data-countrycode="MV" value="960">
                              Maldives (+960)
                            </option>
                            <option data-countrycode="ML" value="223">
                              Mali (+223)
                            </option>
                            <option data-countrycode="MT" value="356">
                              Malta (+356)
                            </option>
                            <option data-countrycode="MH" value="692">
                              Marshall Islands (+692)
                            </option>
                            <option data-countrycode="MQ" value="596">
                              Martinique (+596)
                            </option>
                            <option data-countrycode="MR" value="222">
                              Mauritania (+222)
                            </option>
                            <option data-countrycode="MU" value="230">
                              Mauritius (+230)
                            </option>
                            <option data-countrycode="YT" value="262">
                              Mayotte (+262)
                            </option>
                            <option data-countrycode="MX" value="52">
                              Mexico (+52)
                            </option>
                            <option data-countrycode="FM" value="691">
                              Micronesia (+691)
                            </option>
                            <option data-countrycode="MD" value="373">
                              Moldova (+373)
                            </option>
                            <option data-countrycode="MC" value="377">
                              Monaco (+377)
                            </option>
                            <option data-countrycode="MN" value="976">
                              Mongolia (+976)
                            </option>
                            <option data-countrycode="ME" value="382">
                              Montenegro (+382)
                            </option>
                            <option data-countrycode="MS" value="1664">
                              Montserrat (+1664)
                            </option>
                            <option data-countrycode="MA" value="212">
                              Morocco (+212)
                            </option>
                            <option data-countrycode="MZ" value="258">
                              Mozambique (+258)
                            </option>
                            <option data-countrycode="MM" value="95">
                              Myanmar (+95)
                            </option>
                            <option data-countrycode="NA" value="264">
                              Namibia (+264)
                            </option>
                            <option data-countrycode="NR" value="674">
                              Nauru (+674)
                            </option>
                            <option data-countrycode="NP" value="977">
                              Nepal (+977)
                            </option>
                            <option data-countrycode="NL" value="31">
                              Netherlands (+31)
                            </option>
                            <option data-countrycode="AN" value="599">
                              Netherlands Antilles (+599)
                            </option>
                            <option data-countrycode="NC" value="687">
                              New Caledonia (+687)
                            </option>
                            <option data-countrycode="NZ" value="64">
                              New Zealand (+64)
                            </option>
                            <option data-countrycode="NI" value="505">
                              Nicaragua (+505)
                            </option>
                            <option data-countrycode="NE" value="227">
                              Niger (+227)
                            </option>
                            <option data-countrycode="NU" value="683">
                              Niue (+683)
                            </option>
                            <option data-countrycode="NF" value="672">
                              Norfolk Island (+672)
                            </option>
                            <option data-countrycode="KP" value="850">
                              North Korea (+850)
                            </option>
                            <option data-countrycode="MP" value="1670">
                              Northern Mariana Islands (+1670)
                            </option>
                            <option data-countrycode="NO" value="47">
                              Norway (+47)
                            </option>
                            <option data-countrycode="OM" value="968">
                              Oman (+968)
                            </option>
                            <option data-countrycode="PK" value="92">
                              Pakistan (+92)
                            </option>
                            <option data-countrycode="PW" value="680">
                              Palau (+680)
                            </option>
                            <option data-countrycode="PS" value="970">
                              Palestine (+970)
                            </option>
                            <option data-countrycode="PA" value="507">
                              Panama (+507)
                            </option>
                            <option data-countrycode="PG" value="675">
                              Papua New Guinea (+675)
                            </option>
                            <option data-countrycode="PY" value="595">
                              Paraguay (+595)
                            </option>
                            <option data-countrycode="PE" value="51">
                              Peru (+51)
                            </option>
                            <option data-countrycode="PH" value="63">
                              Philippines (+63)
                            </option>
                            <option data-countrycode="PN" value="64">
                              Pitcairn (+64)
                            </option>
                            <option data-countrycode="PL" value="48">
                              Poland (+48)
                            </option>
                            <option data-countrycode="PT" value="351">
                              Portugal (+351)
                            </option>
                            <option data-countrycode="PR" value="1">
                              Puerto Rico (+1)
                            </option>
                            <option data-countrycode="QA" value="974">
                              Qatar (+974)
                            </option>
                            <option data-countrycode="CG" value="242">
                              Republic of the Congo (+242)
                            </option>
                            <option data-countrycode="RE" value="262">
                              Reunion (+262)
                            </option>
                            <option data-countrycode="RO" value="40">
                              Romania (+40)
                            </option>
                            <option data-countrycode="RU" value="7">
                              Russia (+7)
                            </option>
                            <option data-countrycode="RW" value="250">
                              Rwanda (+250)
                            </option>
                            <option data-countrycode="BL" value="590">
                              Saint Barthelemy (+590)
                            </option>
                            <option data-countrycode="SH" value="290">
                              Saint Helena (+290)
                            </option>
                            <option data-countrycode="KN" value="1869">
                              Saint Kitts &amp; Nevis (+1869)
                            </option>
                            <option data-countrycode="LC" value="1758">
                              Saint Lucia (+1758)
                            </option>
                            <option data-countrycode="MF" value="590">
                              Saint Martin (+590)
                            </option>
                            <option data-countrycode="PM" value="508">
                              Saint Pierre &amp; Miquelon (+508)
                            </option>
                            <option data-countrycode="VC" value="1784">
                              Saint Vincent &amp; the Grenadines (+1784)
                            </option>
                            <option data-countrycode="WS" value="685">
                              Samoa (+685)
                            </option>
                            <option data-countrycode="SM" value="378">
                              San Marino (+378)
                            </option>
                            <option data-countrycode="ST" value="239">
                              Sao Tome &amp; Principe (+239)
                            </option>
                            <option data-countrycode="SA" value="966">
                              Saudi Arabia (+966)
                            </option>
                            <option data-countrycode="SN" value="221">
                              Senegal (+221)
                            </option>
                            <option data-countrycode="RS" value="381">
                              Serbia (+381)
                            </option>
                            <option data-countrycode="SC" value="248">
                              Seychelles (+248)
                            </option>
                            <option data-countrycode="SL" value="232">
                              Sierra Leone (+232)
                            </option>
                            <option data-countrycode="SG" value="65">
                              Singapore (+65)
                            </option>
                            <option data-countrycode="SX" value="1721">
                              Sint Maarten (+1721)
                            </option>
                            <option data-countrycode="SK" value="421">
                              Slovakia (+421)
                            </option>
                            <option data-countrycode="SI" value="386">
                              Slovenia (+386)
                            </option>
                            <option data-countrycode="SB" value="677">
                              Solomon Islands (+677)
                            </option>
                            <option data-countrycode="SO" value="252">
                              Somalia (+252)
                            </option>
                            <option data-countrycode="ZA" value="27">
                              South Africa (+27)
                            </option>
                            <option data-countrycode="KR" value="82">
                              South Korea (+82)
                            </option>
                            <option data-countrycode="SS" value="211">
                              South Sudan (+211)
                            </option>
                            <option data-countrycode="ES" value="34">
                              Spain (+34)
                            </option>
                            <option data-countrycode="LK" value="94">
                              Sri Lanka (+94)
                            </option>
                            <option data-countrycode="SD" value="249">
                              Sudan (+249)
                            </option>
                            <option data-countrycode="SR" value="597">
                              Suriname (+597)
                            </option>
                            <option data-countrycode="SJ" value="47">
                              Svalbard &amp; Jan Mayen (+47)
                            </option>
                            <option data-countrycode="SZ" value="268">
                              Swaziland (+268)
                            </option>
                            <option data-countrycode="SE" value="46">
                              Sweden (+46)
                            </option>
                            <option data-countrycode="CH" value="41">
                              Switzerland (+41)
                            </option>
                            <option data-countrycode="SY" value="963">
                              Syria (+963)
                            </option>
                            <option data-countrycode="TW" value="886">
                              Taiwan (+886)
                            </option>
                            <option data-countrycode="TJ" value="992">
                              Tajikistan (+992)
                            </option>
                            <option data-countrycode="TZ" value="255">
                              Tanzania (+255)
                            </option>
                            <option data-countrycode="TH" value="66">
                              Thailand (+66)
                            </option>
                            <option data-countrycode="TG" value="228">
                              Togo (+228)
                            </option>
                            <option data-countrycode="TK" value="690">
                              Tokelau (+690)
                            </option>
                            <option data-countrycode="TO" value="676">
                              Tonga (+676)
                            </option>
                            <option data-countrycode="TT" value="1868">
                              Trinidad &amp; Tobago (+1868)
                            </option>
                            <option data-countrycode="TN" value="216">
                              Tunisia (+216)
                            </option>
                            <option data-countrycode="TR" value="90">
                              Turkey (+90)
                            </option>
                            <option data-countrycode="TM" value="993">
                              Turkmenistan (+993)
                            </option>
                            <option data-countrycode="TC" value="1649">
                              Turks &amp; Caicos Islands (+1649)
                            </option>
                            <option data-countrycode="TV" value="688">
                              Tuvalu (+688)
                            </option>
                            <option data-countrycode="UG" value="256">
                              Uganda (+256)
                            </option>
                            <option data-countrycode="UA" value="380">
                              Ukraine (+380)
                            </option>
                            <option data-countrycode="AE" value="971">
                              United Arab Emirates (+971)
                            </option>
                            <option data-countrycode="GB" value="44">
                              United Kingdom (+44)
                            </option>
                            <option data-countrycode="US" value="1">
                              United States (+1)
                            </option>
                            <option data-countrycode="UY" value="598">
                              Uruguay (+598)
                            </option>
                            <option data-countrycode="UZ" value="998">
                              Uzbekistan (+998)
                            </option>
                            <option data-countrycode="VU" value="678">
                              Vanuatu (+678)
                            </option>
                            <option data-countrycode="VA" value="379">
                              Vatican (+379)
                            </option>
                            <option data-countrycode="VE" value="58">
                              Venezuela (+58)
                            </option>
                            <option data-countrycode="VN" value="84">
                              Vietnam (+84)
                            </option>
                            <option data-countrycode="WF" value="681">
                              Wallis &amp; Futuna (+681)
                            </option>
                            <option data-countrycode="EH" value="212">
                              Western Sahara (+212)
                            </option>
                            <option data-countrycode="YE" value="967">
                              Yemen (+967)
                            </option>
                            <option data-countrycode="ZM" value="260">
                              Zambia (+260)
                            </option>
                            <option data-countrycode="ZW" value="263">
                              Zimbabwe (+263)
                            </option>
                          </select>
                          <input
                            type="tel"
                            name="phone"
                            id="phone"
                            value={formData.phone}
                            onChange={handleChange}
                            placeholder="Enter your phone number"
                            required
                            className="w-full p-3 border border-gray-300 rounded-r-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
                          />
                        </div>
                      </div>
                      {renderInputField(
                        "age",
                        "How old are you?",
                        "text",
                        true
                      )}
                      {renderInputField(
                        "occupation",
                        "Present occupation, if any",
                        "text",
                        true
                      )}
                      {renderInputField(
                        "yearsOfExperience",
                        "How many years of experience do you have?",
                        "text",
                        true
                      )}
                      {renderTextareaField(
                        "homeAddress",
                        "Enter your Address in full, including State and Zipcode",
                        true
                      )}
                    </div>
                  </fieldset>

                  {/* File Upload Section */}
                  <fieldset className="border p-6 rounded-lg">
                    <legend className="text-xl font-semibold text-gray-800 px-2">
                      File Upload
                    </legend>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4">
                      <div className="w-full">
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          Upload your Resume{" "}
                          <span className="text-red-500">*</span>
                        </label>
                        <input
                          type="file"
                          name="resumeUpload"
                          ref={resumeFileRef}
                          required
                          accept="image/*,application/pdf"
                          className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        />
                      </div>

                      <div className="w-full">
                        {renderTextareaField(
                          "coverLetter",
                          "Add a cover letter, maximum of 1000 words",
                          true
                        )}
                      </div>
                    </div>
                  </fieldset>

                  {/* Signature Section */}
                  <fieldset className="border p-6 rounded-lg">
                    <legend className="text-xl font-semibold text-gray-800 px-2">
                      Signature
                    </legend>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4">
                      {renderInputField("date", "", "date", true)}
                    </div>
                    <p className="text-xs text-gray-600 mt-4">
                      By signing and dating this application, I certify that all
                      statements made are true and complete to the best of my
                      knowledge.
                    </p>
                  </fieldset>

                  <div className="text-center pt-8">
                    <button
                      type="submit"
                      className="w-full md:w-auto px-12 py-3 font-semibold rounded-lg text-white bg-indigo-600 hover:bg-indigo-700 transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                    >
                      Submit Application
                    </button>
                  </div>
                </form>
              </div>
            )}
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
};

export default JobAds;
